"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var literals_1 = __importDefault(require("./literals"));

var Tokenizer =
/** @class */
function () {
  function Tokenizer(code) {
    this.index = -1;
    this.symbolTable = {};
    this.code = code;
    this.tokenize();
  }

  Tokenizer.prototype.tokenize = function () {
    var code = this.code; // remove new lines

    code = code.replace(new RegExp("\n", "g"), Tokenizer.sep); // replace spaces

    code = code.replace(new RegExp(" ", "g"), Tokenizer.sep); // replace tabs

    code = code.replace(new RegExp("\t", "g"), Tokenizer.sep); // surround literals

    literals_1["default"].forEach(function (_a) {
      var regex = _a[0],
          literal = _a[1];
      code = code.replace(regex, Tokenizer.sep + literal + Tokenizer.sep);
    }); // remove doubles seps

    while (code.includes(Tokenizer.doubleSep)) {
      code = code.replace(new RegExp(Tokenizer.doubleSep, "g"), Tokenizer.sep);
    } // split on sep


    this.tokens = code.split(Tokenizer.sep);
    this.tokens = this.tokens.filter(function (s) {
      return s.length > 0;
    });
  };

  Tokenizer.prototype.pop = function () {
    this.index++;
  };

  Tokenizer.prototype.getNext = function () {
    if (this.index + 1 > this.tokens.length - 1) {
      return undefined;
    }

    return this.tokens[this.index + 1];
  };

  Tokenizer.prototype.checkNext = function (checkVal) {
    if (checkVal !== this.getNext()) {
      throw new Error("'" + this.getNext() + "' is not a valid token for this expression. Should be '" + checkVal + "'.");
    }
  };

  Tokenizer.prototype.getNextAndPop = function () {
    var val = this.getNext();
    this.pop();
    return val;
  };

  Tokenizer.prototype.checkNextAndPop = function (checkVal) {
    this.checkNext(checkVal);
    this.pop();
  };

  Tokenizer.prototype.declareToSymbolTable = function (key) {
    this.symbolTable[key] = null;
  };

  Tokenizer.prototype.defineInSymbolTable = function (key, node) {
    this.existsInSymbolTable(key);
    this.symbolTable[key] = node;
  };

  Tokenizer.prototype.existsInSymbolTable = function (key) {
    if (this.symbolTable[key] === undefined) {
      throw new Error("'" + key + "' does not exist in symbolTable.");
    }
  };

  Tokenizer.prototype.getFromSymbolTable = function (key) {
    this.existsInSymbolTable(key);
    return this.symbolTable[key];
  };

  Tokenizer.prototype.remainingTokens = function () {
    return this.tokens.length - 1 - this.index;
  };

  Tokenizer.sep = "_";
  Tokenizer.doubleSep = Tokenizer.sep + Tokenizer.sep;
  return Tokenizer;
}();

exports["default"] = Tokenizer;